import React from 'react';
import { motion } from 'framer-motion';
import { Check, Trophy, X } from 'lucide-react';
import { FlowSteps } from './FlowSteps';
const negatives = ['This is not a random collection of MMA drills.', 'This is not a generic martial arts manual filled with theory you still need to convert into a real session.', 'And it is not a collection of disconnected striking, wrestling and grappling techniques.'];
const mmaFlow = ['Stance & Distance', 'Striking', 'Clinch', 'Takedowns', 'Ground', 'Transitions', 'Complete Application'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-violet-950 relative overflow-hidden" data-id="element-236" data-mp="182knm4lq5axx">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-1 bg-violet-500" data-id="element-237" data-mp="140h9f87o7s8y" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-238" data-mp="2jh7vmgeud3bq">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-239" data-mp="2jfn0opom7idc">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-violet-600 text-white mb-5" data-id="element-240" data-mp="2bxtdywk3z7yb">
            <Trophy size={26} aria-hidden="true" data-id="element-241" data-mp="2kwdp9cncafci" />
          </div>
          <h2 className="text-2xl md:text-4xl font-black uppercase mb-4 text-white" data-id="element-242" data-mp="2kx6olsjyy2km">
            The complete system for MMA coaches worldwide
          </h2>
          <h3 className="text-xl font-extrabold text-violet-300 mb-3" data-id="element-243" data-mp="1t60nb8sihytr">MMA COACH READY</h3>
          <p className="font-display font-bold uppercase tracking-wide text-sm md:text-base text-white/80 mb-10" data-id="element-244" data-mp="1x6b47ghue9ne">
            6 Complete Volumes • 150 Ready-to-Coach Sessions • 5 Professional Bonus Guides
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-245" data-mp="26y714o86ztq1">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-246" data-mp="19i08err0705z">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-247" data-mp="2cqbc4r9xemji">
                <X className="text-white/50 shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-248" data-mp="2qj0xquljlpg3" />
                <p className="text-white/75 text-sm" data-id="element-249" data-mp="2mj8riojmfvdw">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white p-6 rounded-2xl border-2 border-violet-400" data-id="element-250" data-mp="1yuh4ebkw237z">
            <div className="flex items-start gap-3" data-id="element-251" data-mp="22wazm4cbef0r">
              <Check className="text-green-600 shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-252" data-mp="3j76ivigidggg" />
              <p className="text-zinc-950 font-display font-extrabold uppercase text-base leading-snug" data-id="element-253" data-mp="3e83gy6vtrqcp">
                MMA Coach Ready is a complete 6-in-1 visual coaching system.
              </p>
            </div>
          </motion.div>
        </div>

        <div className="mt-10" data-id="element-254" data-mp="3qpeakodhtuet">
          <p className="text-white/70 text-sm mb-4" data-id="element-255" data-mp="3csraicq8uo4o">It is designed around the real flow of MMA:</p>
          <FlowSteps steps={mmaFlow} tone="dark" label="The real flow of MMA" data-id="element-256" data-mp="3hq9ahdma9t0j" />
          <p className="text-base md:text-lg text-white/80 mt-6" data-id="element-257" data-mp="9bhia4xzb0j5">
            Everything is organized to help you teach MMA as one connected system.
          </p>
        </div>
      </div>
    </section>;
}